import { useNavigate } from "react-router-dom";
import resultImg from "../assets/result.jpg";

export default function ResultPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        // justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "25vh",
        }}
      >
        <img style={{ width: 80 }} src={resultImg}></img>
      </div>
      <div style={{ textAlign: "center", marginTop: "24px", fontSize: "18px" }}>
        您的诉求我们已经收到，感谢您的参与！
      </div>
    </div>
  );
}
